import * as Mutations from './mutations';
import {SCHOOL_APP} from '../../../main';

export const ConfirmModule = {

    state: {
        confirmation: null
    },

    mutations: {
       [Mutations.SET_CONFIRMATION] (state, payload) {
           state.confirmation = payload;
       },

        [Mutations.REMOVE_CONFIRMATION] (state) {
           state.confirmation = null;
        }
    },

    actions: {
        openConfirmDialog(context, confirmation) {
            context.commit(Mutations.SET_CONFIRMATION, confirmation);
            SCHOOL_APP.$emit('show-fade');
        },

        closeConfirmDialog(context) {
            const confirmation = this.getters.confirmation;
            confirmation && confirmation.cancelCallback && confirmation.cancelCallback();
            context.commit(Mutations.REMOVE_CONFIRMATION);
            SCHOOL_APP.$emit('hide-fade');
        },

        confirm(context) {
            const confirmation = this.getters.confirmation;
            SCHOOL_APP.$emit('hide-fade');
            if (confirmation) {
                confirmation.callback();
                context.commit(Mutations.REMOVE_CONFIRMATION);
            }
        }
    },

    getters: {
        confirmation: state => state.confirmation,

        title: state => state.confirmation ? state.confirmation.title : null,

        showConfirmDialog: state => Boolean(state.confirmation),

        confirmButtonLabel: state => state.confirmation ? state.confirmation.confirmButtonLabel : 'Yes',

        cancelButtonLabel: state => state.confirmation ? state.confirmation.cancelButtonLabel : 'No',
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/confirm/confirm.module.js